import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="layout"
export default class extends Controller {
  static targets = ["asideToggle", "languageMenu", "userMenu"];

  initialize() {
    this.languageMenuShown = false;
    this.userMenuShown = false;
  }

  toggleLanguageMenu(event) {
    event.preventDefault();

    if (this.languageMenuShown) {
      this.languageMenuShown = false;
      this.languageMenuTarget.style.display = "none";
    } else {
      this.languageMenuShown = true;
      this.languageMenuTarget.style.display = "block";
    }
  }

  toggleUserMenu(event) {
    event.preventDefault();

    if (this.userMenuShown) {
      this.userMenuShown = false;
      this.userMenuTarget.style.display = "none";
    } else {
      this.userMenuShown = true;
      this.userMenuTarget.style.display = "block";
    }
  }

  toggleMinimizedMenu(event) {
    this.asideToggleTarget.classList.toggle("active");
    this.element.classList.toggle("aside-minimized");
  }

  hideLanguageMenu() {
    this.languageMenuTarget.style.display = "none";
  }

  hideUserMenu() {
    this.userMenuTarget.style.display = "none";
  }
}
